import { WebSocketConfig } from '@panamax/websocket';
import { environment } from 'src/environments/environment';

export const WEB_SOCKET_CONFIG: WebSocketConfig = {
    baseUrl: environment.webSocketUrl
};
